module.exports = __webpack_public_path__ + "static/media/55_000055.99e28440.jpg";